import {
  FC, ReactNode, useEffect, useState,
} from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { IStore } from 'app/providers/Store/model/store';
import { useAppDispatch } from 'app/providers/Store';
import { userInit } from 'entities/user/model/actions';
import { UserDetailResponseDto } from 'shared/api';

interface RequireAuthProps {
  children: ReactNode;
}

export const RequireAuth: FC<RequireAuthProps> = ({ children }) => {
  const authorizationStatus = useSelector((state: IStore) => state.userSlice.authorizationStatus);
  const [appInitialized, setAppInitialized] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    switch (authorizationStatus) {
    case UserDetailResponseDto.status.INACTIVE:
      if (location.pathname !== '/registration') {
        navigate('/registration');
      } else {
        setAppInitialized(true);
      }
      break;
    case UserDetailResponseDto.status.SUSPENDED:
      if (location.pathname !== '/suspended') {
        navigate('/suspended');
      } else {
        setAppInitialized(true);
      }
      break;
    case UserDetailResponseDto.status.PENDING:
      if (location.pathname !== '/pending') {
        navigate('/pending');
      } else {
        setAppInitialized(true);
      }
      break;
    case UserDetailResponseDto.status.ACTIVE:
      if (!appInitialized) {
        navigate('/');
      }
      setTimeout(() => setAppInitialized(true), 1000);
      break;
    default:
      dispatch(userInit());
    }
  }, [authorizationStatus, navigate, dispatch, location.pathname]);

  if (!appInitialized) {
    return <Spin fullscreen tip="Загрузка..." />;
  }

  return children;
};
